const loginWindowFeatures = {
};


export default {
  // attributes
  name: '',
  key: '',
  typeCode: '',
  tenantId: '',
  clientId: '',

  // authorize
  authorizeUrl: '',
  authorizeScopeDomain: {
    management: '',
    graph: '',
  },
  authorizeAccessToken: '',
  authorizeWindowFeatures: '',
}



// WEBPACK FOOTER //
// ./src/service/coa/csp/gcp.js